var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7708569e\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./VerifyDocumentIcon.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/VerifyDocumentIcon.vue
// module id = 1459
// module chunks = 159